import { render, staticRenderFns } from "./PSTN.vue?vue&type=template&id=fe949eca&scoped=true&"
import script from "./PSTN.vue?vue&type=script&lang=js&"
export * from "./PSTN.vue?vue&type=script&lang=js&"
import style0 from "./PSTN.vue?vue&type=style&index=0&id=fe949eca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe949eca",
  null
  
)

export default component.exports